import React, { Component } from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';

const ImpressumDetails = () => {
    const { t } = useTranslations();
    return (
        <section className="contact-area pt-20">
            <div className="container">
                <div className="contact-inner">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="contact-features-list">
                                <h4>{t('impressum_page_tmg')}</h4>
                                <p>Simplify Data GmbH</p>
                                <p>Königsweg 48</p>
                                <p>24114 Kiel</p>
                                <br />
                                <h5>{t('impressum_page_representedBy')}</h5>
                                <p>Sebastian Rottgardt</p>
                                <p>Daniel Pantel</p>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <h5>{t('impressum_page_contact')}</h5>
                            <p>E-Mail: <span><Link href="mailto:info@simplify-data.de">info@simplify-data.de</Link></span></p>
                            <br />
                            <h5>{t('impressum_page_registration')}</h5>
                            <p>{t('impressum_page_registration_description')}</p>
                            <p>{t('impressum_page_registration_number')}</p>
                            <br />
                            <h5>{t('impressum_page_taxId')}</h5>
                            <p>{t('impressum_page_taxId_description')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ImpressumDetails;